export default __webpack_public_path__ + "img/no-chat.5722d51a.svg";